"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var shell;
    (function (shell) {
        /**
         * Utility for preventing interactions with the form outside of a specified element.
         */
        // tslint:disable-next-line:class-name
        var surroundingBlockingDiv = /** @class */ (function () {
            function surroundingBlockingDiv(clickHandler, blockingDivClasses) {
                this.clickHandler = clickHandler;
                this.blockingDivClasses = blockingDivClasses;
                this.blocksInitialized = false;
                this.blocksShown = false;
                if (!this.blockingDivClasses) {
                    this.blockingDivClasses = [];
                }
                this.surroundedElement = null;
                this.topBlock = null;
                this.topBlockUsed = false;
                this.rightBlock = null;
                this.rightBlockUsed = false;
                this.bottomBlock = null;
                this.bottomBlockUsed = false;
                this.leftBlock = null;
                this.leftBlockUsed = false;
                this.messagingBlock = null;
                this.messagingBlockUsed = false;
            }
            surroundingBlockingDiv.prototype.init = function () {
                if (this.blocksInitialized) {
                    return;
                }
                var $mainPane = $($dyn.shell.mainPane);
                if (!this.topBlock) {
                    this.topBlock = $("<div tabindex='-1'></div>");
                    this.topBlockUsed = false;
                    $mainPane.append(this.topBlock);
                    this.topBlock[0].style.position = "absolute";
                    this.topBlock[0].style.display = "none";
                    if (!this.messagingBlock) {
                        this.messagingBlock = $("<div class='blockingDivMessaging'></div>");
                        this.messagingBlockUsed = false;
                        this.topBlock.append(this.messagingBlock);
                        this.messagingBlock[0].style.position = "absolute";
                        this.messagingBlock[0].style.display = "none";
                    }
                }
                if (!this.bottomBlock) {
                    this.bottomBlock = $("<div tabindex='-1'></div>");
                    this.bottomBlockUsed = false;
                    $mainPane.append(this.bottomBlock);
                    this.bottomBlock[0].style.position = "absolute";
                    this.bottomBlock[0].style.display = "none";
                }
                if (!this.leftBlock) {
                    this.leftBlock = $("<div tabindex='-1'></div>");
                    this.leftBlockUsed = false;
                    $mainPane.append(this.leftBlock);
                    this.leftBlock[0].style.position = "absolute";
                    this.leftBlock[0].style.display = "none";
                }
                if (!this.rightBlock) {
                    this.rightBlock = $("<div tabindex='-1'></div>");
                    this.rightBlockUsed = false;
                    $mainPane.append(this.rightBlock);
                    this.rightBlock[0].style.position = "absolute";
                    this.rightBlock[0].style.display = "none";
                }
                this.registerClickHandler();
                this.addBlockingDivClasses();
                this.blocksInitialized = true;
            };
            surroundingBlockingDiv.prototype.show = function (targetElem) {
                var $element = $(targetElem);
                var $mainPane = $($dyn.shell.mainPane);
                if (!$.contains($mainPane[0], $element[0])) {
                    return;
                }
                if (!this.blocksInitialized) {
                    this.init();
                }
                this.surroundedElement = targetElem;
                // mainPane
                var mainPaneOffset = $mainPane.offset();
                var mainPaneTopOffset = mainPaneOffset.top;
                var mainPaneLeftOffset = mainPaneOffset.left;
                var mainPaneHeight = $mainPane.height();
                var mainPaneWidth = $mainPane.width();
                // Focused Element
                var elementOffset = $element.offset();
                var elementTopOffset = elementOffset.top;
                var elementLeftOffset = elementOffset.left;
                var elementHeight = $element.outerHeight();
                var elementWidth = $element.outerWidth();
                // Calculate element's offset relative to mainPane
                var elementTop = elementTopOffset - mainPaneTopOffset;
                var elementLeft = elementLeftOffset - mainPaneLeftOffset;
                var elementBottom = mainPaneHeight - elementTop - elementHeight;
                var normalizedTop = elementTop;
                if (normalizedTop < 0) {
                    normalizedTop = 0;
                }
                var normalizedLeft = elementLeft;
                if (normalizedLeft < 0) {
                    normalizedLeft = 0;
                }
                /*  Build top, left, right and bottom blocks as shown below
                -------------------------------------------------
                |                   Top Block                   |
                -------------------------------------------------
                |   Left Block  |   Element    |   Right Block  |
                -------------------------------------------------
                |                 Bottom Block                  |
                -------------------------------------------------
                */
                this.topBlock.css({ "display": "block", "top": 0, "left": 0, "right": 0, "height": +normalizedTop + "px" });
                this.topBlockUsed = true;
                this.bottomBlock.css({ "display": "block", "top": +(elementTop + elementHeight) + "px", "left": 0, "right": 0, "bottom": 0 });
                this.bottomBlockUsed = true;
                this.leftBlock.css({ "display": "block", "top": +elementTop + "px", "left": 0, "height": +elementHeight + "px", "width": +normalizedLeft + "px" });
                this.leftBlockUsed = true;
                this.rightBlock.css({ "display": "block", "top": +elementTop + "px", "left": +(elementLeft + elementWidth) + "px", "right": 0, "bottom": +elementBottom + "px" });
                this.rightBlockUsed = true;
                this.blocksShown = true;
            };
            surroundingBlockingDiv.prototype.display = function () {
                this.blocksShown = true;
                this.topBlock && this.topBlockUsed && this.topBlock.css("display", "block");
                this.bottomBlock && this.bottomBlockUsed && this.bottomBlock.css("display", "block");
                this.leftBlock && this.leftBlockUsed && this.leftBlock.css("display", "block");
                this.rightBlock && this.rightBlockUsed && this.rightBlock.css("display", "block");
            };
            surroundingBlockingDiv.prototype.hide = function () {
                this.blocksShown = false;
                this.topBlock && this.topBlock.css("display", "none");
                this.bottomBlock && this.bottomBlock.css("display", "none");
                this.leftBlock && this.leftBlock.css("display", "none");
                this.rightBlock && this.rightBlock.css("display", "none");
            };
            surroundingBlockingDiv.prototype.showMessagingDiv = function (element) {
                if (this.messagingBlock) {
                    this.messagingBlock[0].style.display = "block";
                    this.messagingBlockUsed = true;
                    if (element) {
                        var boundingClientRect = element.getBoundingClientRect();
                        var leftPixels = boundingClientRect.left + (boundingClientRect.width / 2) - (this.messagingBlock.outerWidth() / 2);
                        this.messagingBlock[0].style.left = leftPixels.toString() + "px";
                    }
                }
            };
            surroundingBlockingDiv.prototype.hideMessagingDiv = function () {
                if (this.messagingBlock) {
                    this.messagingBlock[0].style.display = "none";
                }
                this.messagingBlockUsed = false;
            };
            surroundingBlockingDiv.prototype.setMessagingContent = function (htmlContent) {
                if (this.messagingBlock) {
                    this.messagingBlock.empty();
                    if (htmlContent) {
                        this.messagingBlock.append(htmlContent);
                    }
                }
            };
            surroundingBlockingDiv.prototype.addBlockingDivClasses = function () {
                var e_1, _a;
                if (this.blockingDivClasses && this.blockingDivClasses.length) {
                    try {
                        for (var _b = __values(this.blockingDivClasses), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var className = _c.value;
                            this.topBlock && this.topBlock[0].classList.add(className);
                            this.bottomBlock && this.bottomBlock[0].classList.add(className);
                            this.leftBlock && this.leftBlock[0].classList.add(className);
                            this.rightBlock && this.rightBlock[0].classList.add(className);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
            };
            surroundingBlockingDiv.prototype.removeBlockingDivClass = function (className) {
                this.topBlock && this.topBlock[0].classList.remove(className);
                this.bottomBlock && this.bottomBlock[0].classList.remove(className);
                this.leftBlock && this.leftBlock[0].classList.remove(className);
                this.rightBlock && this.rightBlock[0].classList.remove(className);
            };
            surroundingBlockingDiv.prototype.destroy = function () {
                this.blocksInitialized = false;
                this.blocksShown = false;
                this.topBlock && this.topBlock.remove();
                this.bottomBlock && this.bottomBlock.remove();
                this.leftBlock && this.leftBlock.remove();
                this.rightBlock && this.rightBlock.remove();
                this.topBlock = null;
                this.topBlockUsed = false;
                this.bottomBlock = null;
                this.bottomBlockUsed = false;
                this.leftBlock = null;
                this.leftBlockUsed = false;
                this.rightBlock = null;
                this.rightBlockUsed = false;
                this.messagingBlockUsed = false;
                this.messagingBlock = null;
                this.surroundedElement = null;
            };
            surroundingBlockingDiv.prototype.registerClickHandler = function () {
                if (this.clickHandler) {
                    this.topBlock[0].addEventListener("click", this.clickHandler, true);
                    this.bottomBlock[0].addEventListener("click", this.clickHandler, true);
                    this.leftBlock[0].addEventListener("click", this.clickHandler, true);
                    this.rightBlock[0].addEventListener("click", this.clickHandler, true);
                }
            };
            return surroundingBlockingDiv;
        }());
        shell.surroundingBlockingDiv = surroundingBlockingDiv;
    })(shell = $dyn.shell || ($dyn.shell = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=SurroundingBlockingDiv.js.map
